import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionPlanPreQuestionsRoot } from "./pre-questions";

import type { PlanCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	preQuestions: PlanCategoriesAndManagerStore["preQuestions"];
};

export const QuestionPlanPreQuestions = ({ preQuestions }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper islandTitle="事前質問" categoryStore={preQuestions}>
			<QuestionPlanPreQuestionsRoot />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionPlanPreQuestions.displayName = "QuestionPlanPreQuestions";
